<!-- src/App.vue -->
<template>
  <div>
    <!-- 方案2：简化结构（推荐） -->
    <div class="main-wrapper">
      <router-view />
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessageBox, ElMessage } from 'element-plus'
import Cookies from 'js-cookie'
import axios from 'axios';
import config from '@/config.js';

export default {
  name: 'App',
  setup() {
    const router = useRouter()
    const isLoggedIn = ref(!!Cookies.get('user_token'))

    // 获取并设置网站图标和标题
    const fetchWebConfig = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/shop/api/web_icon.php`)
        if (response.data.success) {
          const { shop_name, h5_favicon } = response.data.data

          // 设置浏览器标题
          document.title = shop_name

          // 设置浏览器图标
          const favicon = document.querySelector("link[rel*='icon']") || document.createElement('link')
          favicon.type = 'image/x-icon'
          favicon.rel = 'shortcut icon'
          favicon.href = h5_favicon
          document.getElementsByTagName('head')[0].appendChild(favicon)
        }
      } catch (error) {
        console.error('获取网站配置失败:', error)
        // 设置默认标题
        document.title = '碰一碰商业版'
      }
    }

    const checkLoginStatus = () => {
      isLoggedIn.value = !!Cookies.get('user_token')
    }

    setInterval(checkLoginStatus, 300)

    watch(
      () => Cookies.get('user_token'),
      (newValue) => {
        isLoggedIn.value = !!newValue
      }
    )

    const handleLogout = async () => {
      try {
        await ElMessageBox.confirm(
          '确定要退出登录吗？所有未保存数据将会丢失！',
          '警告',
          {
            confirmButtonText: '确认退出',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'logout-confirm',
            closeOnClickModal: false
          }
        )

        Cookies.remove('user_token')
        Cookies.remove('user_info')
        isLoggedIn.value = false

        router.push('/login')
        ElMessage.success('您已安全退出系统')
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('退出操作失败，请重试')
        }
      }
    }

    // 在组件挂载时获取配置
    onMounted(() => {
      fetchWebConfig()
    })

    return {
      isLoggedIn,
      handleLogout
    }
  }
}
</script>

<style scoped>
.main-wrapper {
  min-height: 100vh;
  box-sizing: border-box;
  margin: -8px;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.el-upload__tip {
  margin-top: 0 !important;
}


</style>